
function getBookings(entities) {
    return Object.keys(entities.bookings).map(reservationId => {
        return {
            ...entities.bookings[reservationId],
            services: entities.bookings[reservationId].services.map(serviceId => entities.services[serviceId]),
        }
    })
}



export {
    getBookings,
}